"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackShowSearchPopup = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
function trackShowSearchPopup(search_history, search_last_seen_products) {
    const eventData = {
        eventName: enums_1.GA4EventName.ShowSearchPopup,
        feature_category: enums_1.GA4FeatureCategory.Search,
        search_history,
        search_last_seen_products,
    };
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        event: 'JS_Event',
        eventCategory: enums_1.EventCategory.Search,
        eventAction: enums_1.SearchEventType.ShowSearchPopup,
        eventLabel: `${enums_1.GA4SearchEventLabel.SearchHistory} ${eventData.search_history.toString()}|` +
            `${enums_1.GA4SearchEventLabel.SearchLastSeenProducts} ${eventData.search_last_seen_products.toString()}`,
        eventData,
    });
}
exports.trackShowSearchPopup = trackShowSearchPopup;
//# sourceMappingURL=trackShowSearchPopup.js.map